export default __webpack_public_path__ + "static/media/off-24.3199c2ab.png";